import React from 'react';
import { View, ScrollView } from 'react-native';
import { router } from 'expo-router';
import axios from 'axios';
import { TextInput, Button } from 'react-native-paper';
import { useForm, Controller } from "react-hook-form";
import { MainContext } from '../../../contexts/MainContext';

export default function Index(){
  const myContext = React.useContext(MainContext);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const formSubmit = (data) => {
    setSubmitLoading(true);
    Object.keys(data).forEach(key => data[key] === undefined ? delete data[key] : {});
    axios.all([
      axios.post(`/panel/propertyVisit/add`, data),
    ])
      .then(axios.spread((response) => {
        if(response.data.status === true) {
          myContext.activateSnackbar(true, 'درخواست شما با موفقیت ثبت شد'); 
          router.push('/myVisitReport');
        } else {
          myContext.activateSnackbar(true, response.data.message);
        }
      }))
      .catch(myContext.handleAxiosError)
      .finally(() => setSubmitLoading(false));
  }

  return (
    <View style={{ flex: 1, justifyContent: 'space-between', backgroundColor: '#fcfcfd' }}>
      <ScrollView contentContainerStyle={{ paddingHorizontal: 18, paddingVertical: 16, backgroundColor: '#fcfcfd' }}>
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <TextInput
              label="کد آگهی"
              placeholder="کد آگهی مورد نظر را وارد کنید"
              mode="outlined"
              activeOutlineColor="#c6c5c4"
              style={{ marginBottom: 24, fontSize: 14 }}
              error={errors.post_ids}
              onBlur={onBlur}
              onChangeText={onChange}
              defaultValue={value}
              maxLength={4}
              keyboardType='number-pad'
            />
          )}
          name="post_ids"
        />
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <TextInput
              label="کد مشتری"
              placeholder="کد مشتری مورد نظر را وارد کنید"
              mode="outlined"
              activeOutlineColor="#c6c5c4"
              style={{ marginBottom: 24, fontSize: 14 }}
              error={errors.des}
              onBlur={onBlur}
              onChangeText={onChange}
              maxLength={4}
              defaultValue={value}
              keyboardType='number-pad'
            />
          )}
          name="crmId"
        />
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <Controller
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <TextInput
                label="دقیقه"
                placeholder=""
                mode="outlined"
                activeOutlineColor="#c6c5c4"
                style={{ width: '49%', marginBottom: 24, fontSize: 14, textAlign: 'left' }}
                error={errors.des}
                onBlur={onBlur}
                onChangeText={onChange}
                defaultValue={value}
                keyboardType='number-pad'
                maxLength={2}
              />
            )}
            name="minute"
          />
          <Controller
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <TextInput
                label="ساعت"
                placeholder=""
                mode="outlined"
                activeOutlineColor="#c6c5c4"
                style={{ width: '49%', marginBottom: 24, fontSize: 14, textAlign: 'left' }}
                error={errors.des}
                onBlur={onBlur}
                onChangeText={onChange}
                defaultValue={value}
                keyboardType='number-pad'
                maxLength={2}
              />
            )}
            name="hour"
          />
        </View>
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <TextInput
              label="توضیحات"
              placeholder="درصورت وجود توضیحات خود را وارد کنید"
              mode="outlined"
              activeOutlineColor="#c6c5c4"
              multiline
              numberOfLines={4}
              style={{ marginBottom: 24, fontSize: 14 }}
              error={errors.des}
              onBlur={onBlur}
              onChangeText={onChange}
              defaultValue={value}
            />
          )}
          name="des"
        />
      </ScrollView>
      <View style ={{ paddingHorizontal: 18, paddingBottom: 16 }}>
        <Button loading={submitLoading} disabled={submitLoading} labelStyle={{ fontSize: 16 }} style={{ width: '100%', marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={handleSubmit(formSubmit)}>ثبت گزارش</Button>
      </View>
    </View>
  );
};